import { useState } from 'react';

import { useNavigate } from '@tanstack/react-router';

import { Car, Package } from 'lucide-react';

import { Button, cn } from '@src/components/ui';

import { useOnboarding } from './OnboardingContext';
import OnboardingShell from './OnboardingShell';


const CHOICES = [
  {
    value: 'part_out',
    icon: Car,
    title: 'I part out cars',
    description: 'Buy donor vehicles and sell their parts. Track ROI per car.',
  },
  {
    value: 'loose_parts',
    icon: Package,
    title: 'I sell loose parts',
    description: 'Body-shop takeoffs, resale, or enthusiast parts — no donor cars.',
  },
];


function SellerType() {
  const navigate = useNavigate();
  const { draft, update } = useOnboarding();
  const [segment, setSegment] = useState(draft.segment);

  const next = () => {
    update({ segment });
    navigate({ to: '/onboarding/org' });
  };

  return (
    <OnboardingShell
      step={0}
      width="max-w-[640px]"
      title="What do you sell?"
      sub="We'll tailor your setup — you can do both later."
    >
      <div className="flex w-full flex-col gap-4 sm:flex-row">
        {CHOICES.map(({ value, icon: Icon, title, description }) => {
          const selected = segment === value;
          return (
            <Button
              key={value}
              variant="ghost"
              className={cn(
                'h-auto flex-1 cursor-pointer flex-col items-start justify-start gap-3 rounded-xl p-5',
                'text-left transition-colors hover:bg-surface-1 hover:text-ink',
                selected
                  ? 'border-2 border-primary bg-primary-soft hover:bg-primary-soft'
                  : 'border border-hairline bg-surface-1 hover:border-hairline-strong',
              )}
              onClick={() => setSegment(value)}
            >
              <span
                className={cn(
                  'grid size-[42px] place-items-center rounded-lg',
                  selected ? 'bg-primary text-white' : 'border border-hairline bg-surface-2 text-ink-muted',
                )}
              >
                <Icon className="size-5" />
              </span>

              <span className="font-semibold text-ink">{title}</span>
              <span className="whitespace-normal text-table leading-[1.4] text-ink-muted">{description}</span>
            </Button>
          );
        })}
      </div>

      <Button disabled={!segment} className="h-[46px] w-60 max-lg:h-[50px] max-lg:w-full" onClick={next}>
        Continue
      </Button>
    </OnboardingShell>
  );
}

SellerType.displayName = 'SellerType';
export default SellerType;
